module.exports = __webpack_public_path__ + "img/Previleges.b9dad090.png";